import { render, staticRenderFns } from "./libraryClass.vue?vue&type=template&id=604aaf46&scoped=true&"
import script from "./libraryClass.vue?vue&type=script&lang=js&"
export * from "./libraryClass.vue?vue&type=script&lang=js&"
import style0 from "./libraryClass.vue?vue&type=style&index=0&id=604aaf46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604aaf46",
  null
  
)

export default component.exports